import Vue from 'vue'
import VueRouter from 'vue-router'
import Sesion from '../views/Sesion.vue'
import Inicio from '../views/Inicio.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',  
    component: Sesion 
  },
    {
    path:'/inicio',
    name:'Inicio',
    component: Inicio,
    children:[
      {
        path:'/envios',
        name:'Envios',
        component: () => import( '../views/Envios.vue')
      },
      {
        path:'/informacion',
        name:'Envios',
        component: () => import( '../views/Informacion.vue')
      },
      {
        path:'/nuevo',
        name:'Envios',
        component: () => import( '../views/NuevoEnvio.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
